/**
 * Adds sample form events
 * @param {Object} classInstance
 */
export function addSampleFormEvents(classInstance) {
  $('.js-sample-previous').click(() => classInstance.onStepNav('previous'));
}
